export default "__VITE_ASSET__BgHdhnM6__"